export default __webpack_public_path__ + "static/media/folder.9325fc96.svg";